




























































































import Vue from "vue";
import Modal from "@/components/root/modal/Modal.vue";
import { ModalConfig } from "@/components/root/modal";
import { UseLoading } from "@/common/composition/loading";
import { computed, onMounted, Ref, ref } from "@vue/composition-api";
import * as api from "./data/api";
import { JustificationRequest } from "./data/model";
import Spinner from "@/components/Spinner.vue";
import { isEmpty, isNotEmpty } from "@/fp";
import { UseHtmlTemplateHandler } from "@/common/composition/use-html-template-handler";
/*
 task:
 https://dev.azure.com/shieldox/X2O/_workitems/edit/15204
*/
export default Vue.extend({
  components: {
    Modal,
    Spinner,
  },
  props: ["modalData"],
  setup(props, { emit }) {
    const config: ModalConfig = {
      title: "",
      desc: "",
      blank: true,
      width: "60rem",
      withTopRightCloseBtn: true,
      height: "52rem",
    };
    const editable_msg = ref("");
    const status = ref<"idle" | "send_success" | "send_failure">("idle");
    const justification_id = ref("");
    const email_body: Ref<JustificationRequest | null> = ref(null);
    const failure_reason = ref("");
    const initial_full_res: Ref<any> = ref(null);

    const is_failed_to_load_email_body = computed(
      () => !is_loading.value && failure_reason.value.length > 0
    );
    const _props = computed(() => props.modalData as { id: string });
    const [is_loading, set_loading] = UseLoading(false).as_arr();

    const {
      editable_template,
      get_final_template,
      init: init_html_parser,
    } = UseHtmlTemplateHandler(".email_content_container");

    onMounted(async () => {
      set_loading(true);
      const event_id = _props.value.id;
      const res = await api.get_justification_email_body(event_id);
      if (res.success) {
        initial_full_res.value = res.value;
        email_body.value = res.value.request;
        failure_reason.value = res.value.reason || "";
        init_html_parser(res.value.content, {});
      }

      set_loading(false);
    });

    const go_to_event_justification = () => {
      emit("submit", {
        id: justification_id.value,
        action: "event_justification_page",
      });
    };

    const [is_sending, set_is_sending] = UseLoading(false).as_arr();
    const send = async () => {
      set_is_sending(true);
      const final_template = get_final_template();
      // @ts-ignore;
      const event_id = props.modalData.id;
      const res = await api.send_updated_justification({
        event_id,
        content: final_template,
        request: initial_full_res.value.request,
        subject: initial_full_res.value.subject,
      });
      if (res.success) {
        justification_id.value = res.value;
      }
      set_is_sending(false);
      status.value = res.success ? "send_success" : "send_failure";
    };

    const display_name = computed(() => {
      // @ts-ignore
      const { name = "", email = "" } = props.modalData;
      switch (true) {
        case isNotEmpty(name) && isNotEmpty(email):
          return `${name} (${email})`;
        case isNotEmpty(name) && isEmpty(email):
          return `${name} (${email_body.value?.targetUserMail})`;
        case isEmpty(name):
        default:
          return email_body.value?.targetUserMail;
      }
    });

    const close_modal = () => {
      if (status.value == "send_success") {
        emit("submit", { id: justification_id.value });
      } else {
        emit("cancel");
      }
    };

    return {
      config,
      status,
      send,
      close_modal,
      go_to_event_justification,
      is_loading,
      is_sending,
      email_body,
      editable_msg,
      failure_reason,
      editable_template,
      display_name,
      is_failed_to_load_email_body,
      labels: computed(() => {
        if (email_body.value) {
          return Array.from(
            new Set(email_body.value.eventDetails.files.map((d) => d.label))
          ).join(" , ");
        } else {
          return "";
        }
      }),
    };
  },
});
